import styled from 'styled-components';
import Box from '@spotnana/pixel-react/dist/Box';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils/themes/theme';

/**
 * @deprecated please use Grid!
 */
export const LeftSection = styled(Box)`
  flex-grow: 1;
`;

/**
 * @deprecated please use Grid!
 */
export const RightSection = styled(Box)`
  width: 474px;
  flex-shrink: 0;
  margin-left: 38px;

  ${spotnanaTheme.mediaQueries.belowDesktop} {
    margin-left: 0;
    margin-top: 32px;
    width: 100%;
  }
`;
